var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDuplicate = function SvgDuplicate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.005,
    height: 12.994,
    viewBox: "0 0 10.005 12.994",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.059 0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.977 -2.154)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "duplicate a",
    d: "M22.4,15.03H16.1A1.183,1.183,0,0,1,14.977,13.8V5.4A1.183,1.183,0,0,1,16.1,4.171h6.3A1.183,1.183,0,0,1,23.526,5.4V13.8A1.183,1.183,0,0,1,22.4,15.03ZM16.1,4.794a.585.585,0,0,0-.556.61V13.8a.585.585,0,0,0,.556.61h6.3a.585.585,0,0,0,.556-.61V5.4a.585.585,0,0,0-.556-.61Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "duplicate b",
    y1: 1.021,
    transform: "translate(16.599 3.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "duplicate a",
    d: "M23.741,13.461h-.385v-.623h.385a.585.585,0,0,0,.556-.61V3.387a.585.585,0,0,0-.556-.61h-6.3a.585.585,0,0,0-.556.61h-.567a1.183,1.183,0,0,1,1.122-1.233h6.3a1.183,1.183,0,0,1,1.122,1.233v8.841A1.183,1.183,0,0,1,23.741,13.461Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "duplicate c",
    d: "M1.18,12.937A1.183,1.183,0,0,1,.057,11.705V3.312A1.183,1.183,0,0,1,1.18,2.079h.5V1.295H1.4A1.182,1.182,0,0,1,2.517.062h6.3A1.182,1.182,0,0,1,9.943,1.295v8.841a1.182,1.182,0,0,1-1.122,1.232H8.606v.337a1.182,1.182,0,0,1-1.122,1.232ZM.624,3.312v8.393a.585.585,0,0,0,.556.61h6.3a.585.585,0,0,0,.555-.61V3.312a.585.585,0,0,0-.555-.61H1.18A.585.585,0,0,0,.624,3.312ZM1.678,2.079H7.483A1.183,1.183,0,0,1,8.606,3.312v7.434h.215a.585.585,0,0,0,.555-.61V1.295a.585.585,0,0,0-.555-.61h-6.3a.585.585,0,0,0-.556.61H1.678Z",
    transform: "translate(-0.057 -0.062)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuplicate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/duplicate.e123a133.svg";
export { ForwardRef as ReactComponent };